<template>
  <div class="article-detail">
    <h1 v-if="article.Title">{{ article.Title }}</h1>
    <div class="meta" v-if="article.Author && article.CreateTime">
      <span class="author">作者: {{ article.Author.Name }}</span>
      <span class="create-time">{{ formatCreateTime(article.CreateTime) }}</span>
    </div>
    <div v-html="article.Content" class="content" v-if="article.Content"></div>
    <div class="summary" v-if="article.ZhaiYao">
      <strong>摘要:</strong> {{ article.ZhaiYao }}
    </div>
    <div class="images" v-if="filteredImgList.length > 0">
      <img v-for="(img, index) in filteredImgList" :key="index" :src="img" alt="Article Image" class="article-image" />
    </div>
    <div class="like" v-if="article.Like !== undefined">
      <span>点赞: {{ article.Like }}</span>
    </div>
    <div class="share" v-if="article.Share !== undefined">
      <span>分享: {{ article.Share }}</span>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  data() {
    return {
      article: {
        Author: {}
      }
    };
  },
  computed: {
    filteredImgList() {
      return (this.article.imgList || []).filter(img => img);
    }
  },
  methods: {
    async fetchArticle() {
      try {
        const msgId = this.$route.query.MsgID; // 获取 URL 中的 MsgID 参数
        if (!msgId) {
          console.error('MsgID 参数缺失');
          return;
        }
        const response = await axios.get(`/api/article_detail?MsgID=${msgId}`);
        console.log('获取文章详情成功', response.data);

        // 处理 article.Content 中的 href 属性
        response.data.Content = this.replaceHref(response.data.Content);
        response.data.Content = this.replaceImgStyle(response.data.Content);

        this.article = response.data;
      } catch (error) {
        console.error('获取文章详情失败', error);
      }
    },
    formatCreateTime(timestamp) {
      const date = new Date(parseInt(timestamp) * 1000);
      return date.toLocaleString();
    },
    replaceHref(content) {
      // 处理包含 data-name 属性但没有 onclick 属性的情况
      content = content.replace(/<a\s+([^>]*?)href="javascript:void\('([^']*)'\)[^>]*?data-name="([^"]*)"[^>]*>(.*?)<\/a>/gi, (match, beforeHref, _, dataName, linkText) => {
        // 根据 dataName 替换 href 属性的值
        const newHref = `https://www.iwencai.com/unifiedwap/result?w=${encodeURIComponent(dataName)}&querytype=stock`;
        console.log('Matched (data-name):', match);
        console.log('Before Href (data-name):', beforeHref);
        console.log('Data Name (data-name):', dataName);
        console.log('Link Text (data-name):', linkText);
        console.log('New Href (data-name):', newHref);

        // 移除 onclick 属性并添加 target="_blank"
        const cleanedBeforeHref = beforeHref.replace(/onclick="[^"]*"/gi, '').trim();
        console.log('Cleaned Before Href (data-name):', cleanedBeforeHref);

        // 构建新的 a 标签
        const newLink = `<a ${cleanedBeforeHref} href="${newHref}" target="_blank">${linkText}</a>`;
        console.log('New Link (data-name):', newLink);

        return newLink;
      });

      // 处理包含 onclick 属性但没有 data-name 属性的情况
      content = content.replace(/<a\s+([^>]*?)href="javascript:void\('([^']*)'\)[^>]*?onclick="[^"]*"[^>]*>(.*?)<\/a>/gi, (match, beforeHref, _, linkText) => {
        // 根据 linkText 替换 href 属性的值
        const newHref = `https://www.iwencai.com/unifiedwap/result?w=${encodeURIComponent(linkText.replace('【', '').replace('】', ''))}&querytype=stock`;
        console.log('Matched (onclick):', match);
        console.log('Before Href (onclick):', beforeHref);
        console.log('Link Text (onclick):', linkText);
        console.log('New Href (onclick):', newHref);

        // 移除 onclick 属性并添加 target="_blank"
        const cleanedBeforeHref = beforeHref.replace(/onclick="[^"]*"/gi, '').trim();
        console.log('Cleaned Before Href (onclick):', cleanedBeforeHref);

        // 构建新的 a 标签
        const newLink = `<a ${cleanedBeforeHref} href="${newHref}" target="_blank">${linkText}</a>`;
        console.log('New Link (onclick):', newLink);

        return newLink;
      });

      return content;
    },
    replaceImgStyle(content) {
      // 使用正则表达式查找并替换 <img> 标签，添加 style="width:100%"
      let result = content.replace(/<img([^>]*)>/gi, (match) => {
        if (!match.includes('style=')) {
          return match.replace('>', ' style="width:100%;" >');
        } else if (!match.includes('width:100%')) {
          // 如果已经有 style 属性但没有 width:100%，则添加
          return match.replace(/style="([^"]*)"/i, 'style="$1 width:100%;"');
        }
        return match;
      });

      return result;
    }
  },
  mounted() {
    this.fetchArticle();
  }
};
</script>

<style scoped>
.article-detail {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h1 {
  text-align: center;
  color: #333;
  margin-bottom: 20px;
}

.meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.author,
.create-time {
  color: #555;
  font-size: 0.9em;
}

.content {
  margin-bottom: 20px;
}
.content img {
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.summary {
  margin-bottom: 10px;
  color: #555;
}

.images {
  margin-bottom: 20px;
}

img {
  max-width: 100% !important; /* 设置最大宽度为100% */
  height: auto; /* 保持高度自动调整 */
  display: block; /* 确保图片可以正确应用 margin 和 border-radius */
  margin-right: 10px; /* 设置图片之间的水平间距 */
  margin-bottom: 10px; /* 设置图片之间的垂直间距 */
  border-radius: 4px; /* 设置图片的圆角 */
}

.like,
.share {
  color: #888;
  font-size: 0.9em;
}
</style>
